/**
 * Shared Module
 *
 * Contains reusable components, directives, and pipes that are
 * shared across multiple feature modules.
 *
 * This module should be imported by feature modules that need
 * access to shared functionality.
 *
 * Guidelines:
 * - Only include components/directives/pipes that are used in multiple places
 * - Do NOT include services here (use CoreModule for singletons)
 * - Do NOT include feature-specific components
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Migrated Angular components
import { AddonTypeSelectorComponent } from './components/addon-type-selector/addon-type-selector.component';
import { AlertComponent } from './components/alert/alert.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ComboboxComponent } from './components/combobox/combobox.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { InputFieldWithLabelComponent } from './components/input-field-with-label/input-field-with-label.component';
import { PasswordRequirementsComponent } from './components/password-requirements/password-requirements.component';
import { ReservationInputComponent } from './components/reservation-input/reservation-input.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TicketTypeSelectorComponent } from './components/ticket-type-selector/ticket-type-selector.component';
// import { LoaderComponent } from './components/loader/loader.component';

// Upgraded AngularJS directives for use in Angular templates
import { AJS_UPGRADED_COMPONENTS } from '../upgrade/ajs-upgraded-components';

@NgModule({
  declarations: [
    // LoaderComponent,

    // Upgraded AngularJS components (for use in Angular templates)
    ...AJS_UPGRADED_COMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Migrated standalone Angular components
    AddonTypeSelectorComponent,
    AlertComponent,
    CheckboxComponent,
    ComboboxComponent,
    DateRangeComponent,
    FormInputComponent,
    InputFieldComponent,
    InputFieldWithLabelComponent,
    PasswordRequirementsComponent,
    ReservationInputComponent,
    SpinnerComponent,
    TicketTypeSelectorComponent,
  ],
  exports: [
    // Re-export common modules for convenience
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Export shared components
    AddonTypeSelectorComponent,
    AlertComponent,
    CheckboxComponent,
    ComboboxComponent,
    DateRangeComponent,
    FormInputComponent,
    InputFieldComponent,
    InputFieldWithLabelComponent,
    PasswordRequirementsComponent,
    ReservationInputComponent,
    SpinnerComponent,
    TicketTypeSelectorComponent,
    // LoaderComponent,

    // Export upgraded AngularJS components
    ...AJS_UPGRADED_COMPONENTS,
  ],
})
export class SharedModule {}

